/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type DescriptionColumn__ItemFragment = { __typename: 'Item', id: string, description: string, pendingChangeAttributes: any };

export const DescriptionColumn__ItemFragmentDoc = gql`
    fragment DescriptionColumn__Item on Item {
  id
  description
  pendingChangeAttributes
}
    `;